import { createFileRoute } from '@tanstack/react-router'
import { lazy } from 'react'

const Referrals = lazy(() => import('@/components/blockpot/referrals'))

export const Route = createFileRoute('/referrals')({
    component: ReferralsPage,
})

function ReferralsPage() {
    return <Referrals />
}